import { useGetIsOpenChatContainer, useToggleChatContainer } from "_common/hooks/global";
import { useGetDeviceType }                                  from "_common/hooks/global";
import MobileBottomDrawer                                    from "_components/atoms/mobileBottomDrawer";
import Render                                                from "_components/atoms/render";
import ChatContainerWrapper                                  from "_components/features/chat/containerWrapper";
import BroadcastBottom                                       from "_components/templates/BroadcastBottom";

import PlayerContainer from "./components/playerContainer";
import useStyles       from "./styles";

const component = props => {
	const {
		sessions,
		broadcastId,
		theatreModeToggle,
		isMobile,
		previousComments
	} = props;

	const { classes }         = useStyles ( { theatreModeToggle } );
	const isOpenChatContainer = useGetIsOpenChatContainer ();
	const toggleChatContainer = useToggleChatContainer ();

	const deviceType       = useGetDeviceType ();
	const isMobileOrTablet = deviceType === "mobile" || deviceType === "tablet" || isMobile;

	return (
		<div className = { classes.mainContainer }>
			<div className = { classes.playerBodyContainer }>
				<PlayerContainer
					broadcastId = { broadcastId }
					isStreamer  = { false }
				/>

				{
					!theatreModeToggle && sessions?.length ? (
						<BroadcastBottom
							broadcastId = { broadcastId }
							isMobile    = { isMobile }
							sessions    = { sessions }
						/>
					) : null
				}
			</div>

			<Render condition = { !isMobileOrTablet }>
				<ChatContainerWrapper
					broadcastId      = { broadcastId }
					isMobile         = { isMobile }
					previousComments = { previousComments }
				/>
			</Render>

			<MobileBottomDrawer
				noBorderRadius
				noOverlay
				closeOnClickOutside = { false }
				isOpen              = { isMobileOrTablet && isOpenChatContainer }
				onClose             = { () => toggleChatContainer ( false ) }
				zIndex              = { 10 }
			>
				<ChatContainerWrapper
					broadcastId      = { broadcastId }
					isMobile         = { isMobile }
					previousComments = { previousComments }
				/>
			</MobileBottomDrawer>

		</div>
	);
};

export default component;
